export const getURLWithQueryAdd = (url: string, query?: string) => {
  const _url = new URL(url);
  if (query) {
    const _searchParams = new URLSearchParams(query);
    _searchParams.forEach((value, key) => {
      _url.searchParams.set(key, value);
    });
  }
  return _url;
};
